// Initialize Firebase Remote Config and populate the Zustand store
import { initRemoteConfig } from './firebaseRemoteConfig';
import { useRemoteConfigStore } from '../store/remoteConfigStore';

let isInitializing = false;

export async function initRemoteConfigValues() {
  // Prevent multiple simultaneous initializations
  if (isInitializing) {
    return;
  }

  const store = useRemoteConfigStore.getState();
  
  // Skip if already initialized
  if (store.isInitialized) {
    return;
  }

  isInitializing = true;

  try {
    // Initialize Firebase Remote Config
    const remoteConfigClient = await initRemoteConfig();

    if (remoteConfigClient) {
      // Fetch and activate latest values (respects 12-hour cache)
      await remoteConfigClient.fetchAndActivate();

      // Get all config values
      const configValues = remoteConfigClient.getAllConfigValues();

      // Update the store with fetched values
      store.setConfig(configValues);
      store.setInitialized(true);

      // console.log('[remote-config] Values initialized:', configValues);
    } else {
      // Firebase not configured, use defaults
      console.warn('[remote-config] Firebase not configured, using default values');
      store.setInitialized(true);
    }
  } catch (error) {
    console.error('[remote-config] Failed to initialize:', error);
    // Still mark as initialized to use default values
    store.setInitialized(true);
  } finally {
    isInitializing = false;
  }
}
